import { Injectable } from '@angular/core';
import { LayoutUtilsService } from '../core/_base/crud';
import { Router, ActivatedRoute } from '@angular/router';
// import { trim } from 'lodash';
import * as dayjs from 'dayjs';
import * as jsPDF from 'jspdf';
import { UserData } from './data.model';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from './api.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { OtherApiService } from './other.service';
import * as moment from 'moment';

import { environment } from 'src/environments/environment';
import { ImageCompressorService, ImageCompressOptions, CompressedImageResult } from './image-compressor.service';
import { FutureDateDialogComponent } from '../components/partials/content/shared/futureDateDialog/future-date-dialog.component';
@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  loginUrl: string = environment.loginUrl;
  permissions = localStorage.getItem('permissions');
  entityId = localStorage.getItem('entityId');
  session = localStorage.getItem('session');
  userId = localStorage.getItem('userId');
  defaultUserPreferences = {
    favourites: [],
    user: this.userId
  }
  storedPrefs = localStorage.getItem('userPreferences');
  userPreferences = this.storedPrefs
  ? { ...this.defaultUserPreferences, ...JSON.parse(this.storedPrefs) }
  : this.defaultUserPreferences;
  studentId: any;
  allCourseList: UserData[];
  constructor(private layoutUtilsService: LayoutUtilsService, private router: Router, private route: ActivatedRoute, private service: OtherApiService, private imageCompressor: ImageCompressorService, private dialog: MatDialog) { }

  checkFutureDate(selectedDate: any, onCancel?: () => void, onConfirm?: () => void) {
    if (!selectedDate) return;
    const selected = moment(selectedDate).startOf('day');
    const today = moment().startOf('day');
    if (selected.isAfter(today)) {
      const formattedDate = moment(selectedDate).format('DD/MM/YYYY');
      const dialogRef = this.dialog.open(FutureDateDialogComponent, {
        width: '440px',
        disableClose: true,
        data: {
          date: selectedDate,
          formattedDate: formattedDate
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (onConfirm) onConfirm();
        } else {
          if (onCancel) onCancel();
        }
      });
    } else {
      if (onConfirm) onConfirm();
    }
  }
  storageSubject = new BehaviorSubject<any>(this.userPreferences);
  staticFavouriteList: any =[
		"Export Data",
		"University Data",
		"Student Payment Summary",
		"Fee Summary - Course Wise",
		"Fee Summary - Category Wise",
		"Fee Summary - Head Wise",
		"Fee Summary - Group Wise",
		"Manage Cash",
		"Attendance Summary",
		"Institute Summary",
		"Daily Schedule For Employees",
		"Employee Schedule",
		"Course Wise Schedule",
		"Time Table Status",
		"Scheduler Logs",
		"Pending Assessment Marks",
		"Green Sheet",
		"Examination Insights",
		"Admission Summary",
		"Partner Registration Summary",
		"Partner Admission Summary",
		"Partner Placement Summary",
		"Placement Summary",
		"Partner Summary Session Wise",
		"Partner Placement Summary Session Wise",
		"Registration Summary",
		"Stock Verify",
    "Insights",
    "Class Test Green Sheet"
	   ];
  // Observable for other components to subscribe to
  // storageObservable$ = this.storageSubject.asObservable();


  // Get data from localStorage
  getItem(key: string): any {
    const item = localStorage.getItem(key);
    return item
  }

  // Update an object in localStorage and notify subscribers
  updateItem(key: string, newValue: any): void {
    this.storageSubject.next(newValue); // Notify subscribers of the update
    localStorage.setItem(key, JSON.stringify(newValue));
  }

  isExtraMarksEntity(): boolean {
    try {
      const entityData = JSON.parse(localStorage.getItem('entityData'));
      if (entityData) {
        if (entityData.extraMarksEntity === true || entityData.extraMarksEntity === 'true') {
          return true;
        }
        if (entityData.name && entityData.name.toLowerCase().includes('extramarks')) {
          return true;
        }
        if (entityData.displayName && entityData.displayName.toLowerCase().includes('extramarks')) {
          return true;
        }
        if (entityData.qac && entityData.qac.toLowerCase().includes('extramarks')) {
          return true;
        }
      }
    } catch (e) {}
    try {
      const entityPreferences = JSON.parse(localStorage.getItem('entityPreferences'));
      if (entityPreferences && (entityPreferences.extraMarksEntity === true || entityPreferences.extraMarksEntity === 'true')) {
        return true;
      }
    } catch (e) {}
    if (localStorage.getItem('extraMarksEntity') === 'true') {
      return true;
    }
    const qac = localStorage.getItem('qac');
    if (qac && qac.toLowerCase().includes('extramarks')) {
      return true;
    }
    const entityName = localStorage.getItem('entityName');
    if (entityName && entityName.toLowerCase().includes('extramarks')) {
      return true;
    }
    if (typeof window !== 'undefined' && window.location) {
      const host = (window.location.hostname || '') + (window.location.href || '');
      if (host.toLowerCase().includes('extramarks')) {
        return true;
      }
    }
    return false;
  }

  fetchAndSyncExtraMarksEntity(entityId?: string): Promise<boolean> {
    const id = entityId || localStorage.getItem('entityId');
    if (this.isExtraMarksEntity()) {
      return Promise.resolve(true);
    }
    if (!id || !this.service) {
      return Promise.resolve(false);
    }
    return new Promise((resolve) => {
      this.service.getEntityData(id).subscribe(
        (res: any) => {
          if (res && (res.extraMarksEntity === true || res.extraMarksEntity === 'true' ||
              (res.name && res.name.toLowerCase().includes('extramarks')) ||
              (res.displayName && res.displayName.toLowerCase().includes('extramarks')) ||
              (res.qac && res.qac.toLowerCase().includes('extramarks')))) {
            try {
              const entityData = JSON.parse(localStorage.getItem('entityData')) || {};
              entityData.extraMarksEntity = true;
              localStorage.setItem('entityData', JSON.stringify(entityData));
              localStorage.setItem('extraMarksEntity', 'true');
            } catch (e) {}
            resolve(true);
          } else {
            resolve(false);
          }
        },
        () => resolve(this.isExtraMarksEntity())
      );
    });
  }
  errmsg(err) {
    if (err == null) {
      // alert('Unable to load Response');
      this.layoutUtilsService.showErrorNotification('Unable to load Response',10000, true);
      return;
    }
    if (err.statusText == 'Unknown Error') {
      // alert('Unable to  connect to server');
      this.layoutUtilsService.showErrorNotification('Unable to  connect to server',10000, true);
      return;
    }
    if (err.statusText == 'Not Acceptable') {
      const hasXToken = !!this.getCookie('x-token');
      const hasNoRedirect = !!this.getCookie('noRedirect');
      // alert(err.error.message)
      this.layoutUtilsService.showErrorNotification(err.error.message,10000, true);
      localStorage.removeItem('token');
      localStorage.removeItem('isExternalLogin');
      localStorage.removeItem('name')
      localStorage.removeItem('userType');
      localStorage.removeItem('session');
      localStorage.removeItem('mobile');
      localStorage.removeItem('sessionEndDate');
      localStorage.removeItem('sessionStartDate');
      localStorage.removeItem('entityType');
      localStorage.removeItem('entityId');
      localStorage.removeItem('homeEntityId');
      localStorage.removeItem('logo')
      localStorage.removeItem('entityName')
      localStorage.removeItem('primaryColour')
      localStorage.removeItem('permissions')
      localStorage.removeItem('courseByTeacherData')
      localStorage.removeItem('courseByTeacherDataDateWise');
      localStorage.removeItem('estimatedCollections');
		localStorage.removeItem('estimatedCollectionsDate');
      this.removeCookie('x-token');
      this.removeCookie('noRedirect');
      if (hasXToken && !hasNoRedirect) {
        window.location.href = environment.extraMarksConfig.logout;
      } else {
        this.router.navigate(['/auth/signin']);
      }
      return;

    }
    if (err.status == 406) {
      const hasXToken = !!this.getCookie('x-token');
      const hasNoRedirect = !!this.getCookie('noRedirect');
      this.layoutUtilsService.showErrorNotification(err.error.message,1000,true)
      localStorage.removeItem('token');
      localStorage.removeItem('isExternalLogin');
      localStorage.removeItem('name')
      localStorage.removeItem('userType');
      localStorage.removeItem('session');
      localStorage.removeItem('mobile');
      localStorage.removeItem('sessionEndDate');
      localStorage.removeItem('sessionStartDate');
      localStorage.removeItem('entityType');
      localStorage.removeItem('entityId');
      localStorage.removeItem('homeEntityId');
      localStorage.removeItem('logo')
      localStorage.removeItem('entityName')
      localStorage.removeItem('primaryColour')
      localStorage.removeItem('permissions')
      localStorage.removeItem('courseByTeacherData')
      localStorage.removeItem('courseByTeacherDataDateWise');
      localStorage.removeItem('estimatedCollections');
		localStorage.removeItem('estimatedCollectionsDate');
      this.removeCookie('x-token');
      this.removeCookie('noRedirect');
      if (hasXToken && !hasNoRedirect) {
        window.location.href = environment.extraMarksConfig.logout;
      } else {
        this.router.navigate(['/auth/signin']);
      }
      return;

    }
    if (err.status == 408) {
      this.confirmAlert('Need to Reload the page', 'Ok', '').subscribe(res => {
        if (res) {
          localStorage.removeItem('courseByTeacherData');
          localStorage.removeItem('courseByTeacherDataDateWise');
          window.location.reload();
        }
      });
      return;
    }
    if (err.status == 504) {
      this.layoutUtilsService.showAlertNotification('Looks like your network is having trouble. Check and retry in a moment.', true);
      return;
    }
    if (err.statusText == 'Not Found') {
      // alert('Invalid Request URL');
      this.layoutUtilsService.showErrorNotification('Invalid Request URL',10000, true);
      return;
    }
    if (err && err.error && err.error.missingAttendance) {
      // alert('Add Studdent Attendance Missssing Value')
      this.layoutUtilsService.showErrorNotification('Add Student Attendance Missing Value',10000, true);
      return;
    }
     if (err && err.error && err.error.message && err.error.message.message) {
      // alert(err.error.message);
      this.layoutUtilsService.showErrorNotification(err.error.message.message,10000, true);
      return
    }
    if (err && err.error && err.error.message) {
      // alert(err.error.message);
      this.layoutUtilsService.showErrorNotification(err.error.message,10000, true);
      return
    } else {
      // alert(err.error.errmsg);
      this.layoutUtilsService.showErrorNotification(err.error.errmsg,10000, true);
      return
    }
  }
  downloadPdf(data, name) {
    var doc = new jsPDF();
    doc.setFontSize(10);
    let currY = 20;
    let pageHeight = doc.internal.pageSize.height;
    let margin = 20; // Margin for the text

    for (let item of data) {
      // Split text into multiple lines if it exceeds the page width
      item=item.toString()
      let splitTitle = doc.splitTextToSize(item, 180);

      for (var i = 0; i < splitTitle.length; i++) {
        if (currY > (pageHeight - margin)) {
          doc.addPage();
          currY = margin; // Reset Y position after adding a new page
        }
        doc.text(margin, currY, splitTitle[i]);
        currY += 5; // Increase Y position for the next line of text
      }
      currY += 2; // Add extra space between items
    }

    // Save the PDF with the specified name
    doc.save(name);
  }

  /**
   * Downloads a structured PDF report for biometric attendance pull logs.
   * Shows date-wise success and failed records in table format.
   */
  downloadBiometricLogsPdf(
    successRecords: { [date: string]: any[] },
    failedRecords:  { [date: string]: any[] },
    reportPeriod: string,
    generatedOn: string
  ) {
    const doc = new jsPDF();
    const pageWidth  = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 14;
    const colWidths = { no: 10, empId: 28, name: 48, time: 24, error: 76 };
    let y = 14;

    const checkPage = (needed = 8) => {
      if (y + needed > pageHeight - 10) {
        doc.addPage();
        y = 14;
      }
    };

    // ── Title ──────────────────────────────────────────────────────────────
    doc.setFillColor(15, 52, 96);
    doc.rect(0, 0, pageWidth, 22, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(13);
    doc.setFontStyle('bold');
    doc.text('Biometric Attendance Pull Logs', margin, 14);
    y = 28;

    // ── Meta ───────────────────────────────────────────────────────────────
    doc.setTextColor(40, 40, 40);
    doc.setFontSize(9);
    doc.setFontStyle('normal');
    doc.text(`Report Period: ${reportPeriod}`, margin, y);
    doc.text(`Generated On: ${generatedOn}`, margin + 100, y);
    y += 6;

    // ── Summary ────────────────────────────────────────────────────────────
    const totalSuccess = Object.values(successRecords || {}).reduce((a, arr) => a + arr.length, 0);
    const totalFailed  = Object.values(failedRecords  || {}).reduce((a, arr) => a + arr.length, 0);
    doc.setFontSize(9);
    doc.setTextColor(56, 142, 60);
    doc.setFontStyle('bold');
    doc.text(`Total Success: ${totalSuccess}`, margin, y);
    doc.setTextColor(198, 40, 40);
    doc.text(`Total Failed: ${totalFailed}`, margin + 60, y);
    y += 8;

    // Helper: draw a table row
    const drawRow = (cols: string[], x: number, widths: number[], isHeader: boolean) => {
      const rowH = 7;
      checkPage(rowH + 2);
      if (isHeader) {
        doc.setFillColor(15, 52, 96);
        doc.rect(x, y, widths.reduce((a, b) => a + b, 0), rowH, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontStyle('bold');
      } else {
        doc.setTextColor(40, 40, 40);
        doc.setFontStyle('normal');
      }
      doc.setFontSize(8);
      let cx = x + 2;
      cols.forEach((col, i) => {
        const split = doc.splitTextToSize(col || '', widths[i] - 3);
        doc.text(split[0] || '', cx, y + 5);
        cx += widths[i];
      });
      doc.setDrawColor(200, 200, 200);
      doc.rect(x, y, widths.reduce((a, b) => a + b, 0), rowH);
      y += rowH;
    };

    // ──────────────────────────────────────────────────────────────────────
    // SUCCESS RECORDS
    // ──────────────────────────────────────────────────────────────────────
    const successDates = Object.keys(successRecords || {}).sort();
    if (successDates.length > 0) {
      checkPage(14);
      doc.setFontSize(11);
      doc.setFontStyle('bold');
      doc.setTextColor(56, 142, 60);
      doc.text('Detailed Success Records', margin, y);
      y += 2;
      doc.setDrawColor(56, 142, 60);
      doc.setLineWidth(0.5);
      doc.line(margin, y, pageWidth - margin, y);
      y += 5;

      for (const date of successDates) {
        const records = successRecords[date] || [];
        checkPage(16);

        // Date header
        doc.setFillColor(232, 245, 233);
        doc.rect(margin, y, pageWidth - margin * 2, 6, 'F');
        doc.setFontSize(9);
        doc.setFontStyle('bold');
        doc.setTextColor(27, 94, 32);
        doc.text(`Date: ${date}   (${records.length} records)`, margin + 2, y + 4.5);
        y += 7;

        // Table header
        const sWidths = [colWidths.no, colWidths.empId, colWidths.name, colWidths.time];
        drawRow(['#', 'Employee ID', 'Name', 'Time'], margin, sWidths, true);

        records.forEach((rec, i) => {
          checkPage(8);
          const bg = i % 2 === 0;
          if (bg) {
            doc.setFillColor(245, 250, 245);
            doc.rect(margin, y, sWidths.reduce((a, b) => a + b, 0), 7, 'F');
          }
          drawRow([String(i + 1), rec.employeeId || '', rec.name || '', rec.time || ''], margin, sWidths, false);
        });
        y += 4;
      }
    }

    // ──────────────────────────────────────────────────────────────────────
    // FAILED RECORDS
    // ──────────────────────────────────────────────────────────────────────
    const failedDates = Object.keys(failedRecords || {}).sort();
    if (failedDates.length > 0) {
      checkPage(14);
      doc.setFontSize(11);
      doc.setFontStyle('bold');
      doc.setTextColor(198, 40, 40);
      doc.text('Detailed Error Records', margin, y);
      y += 2;
      doc.setDrawColor(198, 40, 40);
      doc.setLineWidth(0.5);
      doc.line(margin, y, pageWidth - margin, y);
      y += 5;

      for (const date of failedDates) {
        const records = failedRecords[date] || [];
        checkPage(16);

        // Date header
        doc.setFillColor(255, 235, 238);
        doc.rect(margin, y, pageWidth - margin * 2, 6, 'F');
        doc.setFontSize(9);
        doc.setFontStyle('bold');
        doc.setTextColor(183, 28, 28);
        doc.text(`Date: ${date}   (${records.length} errors)`, margin + 2, y + 4.5);
        y += 7;

        // Table header (wider — includes error column)
        const fWidths = [colWidths.no, colWidths.empId, colWidths.name, colWidths.time, colWidths.error];
        drawRow(['#', 'Employee ID', 'Name', 'Time', 'Error Reason'], margin, fWidths, true);

        records.forEach((rec, i) => {
          const rowH = 7;
          checkPage(rowH + 2);
          const bg = i % 2 === 0;
          if (bg) {
            doc.setFillColor(255, 245, 245);
            doc.rect(margin, y, fWidths.reduce((a, b) => a + b, 0), rowH, 'F');
          }
          // Error reason can be long — draw manually to allow splitting
          doc.setTextColor(40, 40, 40);
          doc.setFontStyle('normal');
          doc.setFontSize(8);
          const cells = [String(i + 1), rec.employeeId || '', rec.name || '', rec.time || ''];
          let cx = margin + 2;
          cells.forEach((cell, ci) => {
            doc.text(cell, cx, y + 5);
            cx += fWidths[ci];
          });
          // Error reason — wrap and expand row if needed
          const errorText = doc.splitTextToSize(rec.errorType || '', fWidths[4] - 3);
          doc.setTextColor(183, 28, 28);
          doc.text(errorText[0] || '', cx, y + 5);
          doc.setDrawColor(200, 200, 200);
          doc.rect(margin, y, fWidths.reduce((a, b) => a + b, 0), rowH);
          y += rowH;
        });
        y += 4;
      }
    }

    doc.save(`Biometric_Attendance_Logs_${reportPeriod.replace(/ /g, '_')}.pdf`);
  }

  downloadPdfWithArray(data: { regNo: number; message: string[] }[], name: string) {
  const doc = new jsPDF();
  doc.setFontSize(10);

  let currY = 20;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 20;

  for (let item of data) {
    // Safely access regNo and message
    const regNoText = `Reg No: ${item.regNo ?item.regNo :'N/A'}`;
    const messages = item.message ?item.message: [];

    // Print Reg No
    if (currY > pageHeight - margin) {
      doc.addPage();
      currY = margin;
    }
    doc.text(margin, currY, regNoText);
    currY += 6;

    // Print each message
    for (let msg of messages) {
      const splitMsg = doc.splitTextToSize(`- ${msg}`, 180);
      for (const line of splitMsg) {
        if (currY > pageHeight - margin) {
          doc.addPage();
          currY = margin;
        }
        doc.text(margin + 5, currY, line);
        currY += 5;
      }
    }

    currY += 8; // Extra space between entries
  }

  doc.save(name);
}

  downloadPdfWithKeys(data,name)
  {
    var doc = new jsPDF();
    doc.setFontSize(10);
    let currY = 20;
    let pageHeight = doc.internal.pageSize.height;
    let margin = 20; // Margin for the text

    for (let item of data) {
      for (let key in item) {
        if (item.hasOwnProperty(key)) {
          // Prepare the text to be added to the PDF
          let text = `${key}: ${item[key]}`;
          // Split text into multiple lines if it exceeds the page width
          let splitText = doc.splitTextToSize(text, 180);

          for (let i = 0; i < splitText.length; i++) {
            if (currY > (pageHeight - margin)) {
              doc.addPage();
              currY = margin; // Reset Y position after adding a new page
            }
            doc.text(margin, currY, splitText[i]);
            currY += 5; // Increase Y position for the next line of text
          }
          currY += 2; // Add extra space between items
        }
      }
      currY += 10; // Add extra space between objects
    }

    // Save the PDF with the specified name
    doc.save(name);
  }
  downloadPdfBulkInactiveKeys(data: any[], name: string) {
    const doc = new jsPDF();
    doc.setFontSize(10);

    let currY = 20;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 20;
    const lineHeight = 6;

    // Optional title
    doc.setFontSize(12);
    doc.text(margin, 15, 'Student Errors');
    doc.setFontSize(10);

    data.forEach((item, index) => {
      const lineText = `• ${item.regNo} - ${item.error}`;

      const splitText = doc.splitTextToSize(lineText, 170);

      splitText.forEach((line: string) => {
        if (currY > pageHeight - margin) {
          doc.addPage();
          currY = margin;
        }
        doc.text(margin, currY, line);
        currY += lineHeight;
      });

      currY += 4; // space between entries
    });

    doc.save(name);
  }

  convert_number(number) {
    if ((number < 0) || (number > 999999999)) {
      return "NUMBER OUT OF RANGE!";
    }
    var Gn = Math.floor(number / 10000000);  /* Crore */
    number -= Gn * 10000000;
    var kn = Math.floor(number / 100000);     /* lakhs */
    number -= kn * 100000;
    var Hn = Math.floor(number / 1000);      /* thousand */
    number -= Hn * 1000;
    var Dn = Math.floor(number / 100);       /* Tens (deca) */
    number = number % 100;               /* Ones */
    var tn = Math.floor(number / 10);
    var one = Math.floor(number % 10);
    var res = "";

    if (Gn > 0) {
      res += (this.convert_number(Gn) + " CRORE");
    }
    if (kn > 0) {
      res += (((res == "") ? "" : " ") +
        this.convert_number(kn) + " LAKH");
    }
    if (Hn > 0) {
      res += (((res == "") ? "" : " ") +
        this.convert_number(Hn) + " THOUSAND");
    }

    if (Dn) {
      res += (((res == "") ? "" : " ") +
        this.convert_number(Dn) + " HUNDRED");
    }


    var ones = Array("", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX", "SEVEN", "EIGHT", "NINE", "TEN", "ELEVEN", "TWELVE", "THIRTEEN", "FOURTEEN", "FIFTEEN", "SIXTEEN", "SEVENTEEN", "EIGHTEEN", "NINETEEN");
    var tens = Array("", "", "TWENTY", "THIRTY", "FOURTY", "FIFTY", "SIXTY", "SEVENTY", "EIGHTY", "NINETY");

    if (tn > 0 || one > 0) {
      if (!(res == "")) {
        res += " AND ";
      }
      if (tn < 2) {
        res += ones[tn * 10 + one];
      }
      else {

        res += tens[tn];
        if (one > 0) {
          res += ("-" + ones[one]);
        }
      }
    }

    if (res == "") {
      res = "zero";
    }
    return res;
  }
  toWords(s) {

    var th = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];
    var dg = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven',
      'Eight', 'Nine'];
    var tn = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
      'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    var tw = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'ninety'];

    s = s.toString();
    s = s.replace(/[\, ]/g, '');
    if (s != parseFloat(s)) return 'not a number';
    var x = s.indexOf('.');
    if (x == -1) x = s.length;
    if (x > 15) return 'too big';
    var n = s.split(''); var str = '';
    var sk = 0; for (var i = 0; i < x; i++) {
      if ((x - i) % 3 == 2) {
        if (n[i] == '1') {
          str += tn[Number(n[i + 1])] + ' ';
          i++; sk = 1;
        } else if (n[i] != 0) { str += tw[n[i] - 2] + ' '; sk = 1; }
      } else if (n[i] != 0) {
        str += dg[n[i]] + ' '; if ((x - i) % 3 == 0) str += 'hundred ';
        sk = 1;
      } if ((x - i) % 3 == 1) {
        if (sk) str += th[(x - i - 1) / 3] + ' ';
        sk = 0;
      }
    }
    if (x != s.length) {
      var y = s.length; str += 'point ';
      for (let i = x + 1; i < y; i++) str += dg[n[i]] + ' ';
    }
    return str.replace(/\s+/g, ' ');
  }
  numberToWords(number) {
    const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    const scales = ['', 'thousand', 'lakh', 'crore'];

    if (number === 0) {
        return 'zero';
    }

    let words = '';

    // Get the crore part
    if (Math.floor(number / 10000000) > 0) {
        words += this.convertChunk(Math.floor(number / 10000000), ones, tens) + ' crore ';
        number = number % 10000000;
    }

    // Get the lakh part
    if (Math.floor(number / 100000) > 0) {
        words += this.convertChunk(Math.floor(number / 100000), ones, tens) + ' lakh ';
        number = number % 100000;
    }

    // Get the thousand part
    if (Math.floor(number / 1000) > 0) {
        words += this.convertChunk(Math.floor(number / 1000), ones, tens) + ' thousand ';
        number = number % 1000;
    }

    // Get the hundred part
    if (Math.floor(number / 100) > 0) {
        words += this.convertChunk(Math.floor(number / 100), ones, tens) + ' hundred ';
        number = number % 100;
    }

    // Get the remaining part (less than 100)
    if (number > 0) {
        words += this.convertChunk(number, ones, tens);
    }

    return words.trim();
}
numberToWordsDecimal(number) {
  const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  if (number === 0) {
      return 'zero';
  }

  let [integerPart, decimalPart] = number.toString().split('.');
  integerPart = parseInt(integerPart, 10);

  let words = '';

  // Process integer part
  if (Math.floor(integerPart / 10000000) > 0) {
      words += this.convertChunk(Math.floor(integerPart / 10000000), ones, tens) + ' crore ';
      integerPart = integerPart % 10000000;
  }
  if (Math.floor(integerPart / 100000) > 0) {
      words += this.convertChunk(Math.floor(integerPart / 100000), ones, tens) + ' lakh ';
      integerPart = integerPart % 100000;
  }
  if (Math.floor(integerPart / 1000) > 0) {
      words += this.convertChunk(Math.floor(integerPart / 1000), ones, tens) + ' thousand ';
      integerPart = integerPart % 1000;
  }
  if (Math.floor(integerPart / 100) > 0) {
      words += this.convertChunk(Math.floor(integerPart / 100), ones, tens) + ' hundred ';
      integerPart = integerPart % 100;
  }
  if (integerPart > 0) {
      words += this.convertChunk(integerPart, ones, tens);
  }

  // Process decimal part if exists
  if (decimalPart) {
      words += ' point';
      for (let digit of decimalPart) {
          words += ' ' + ones[parseInt(digit, 10)];
      }
  }

  return words.trim();
}

convertChunkDecimal(number, ones, tens) {
  let words = '';
  if (number < 20) {
      words += ones[number];
  } else {
      words += tens[Math.floor(number / 10)];
      if (number % 10 > 0) {
          words += ' ' + ones[number % 10];
      }
  }
  return words;
}


convertChunk(number, ones, tens) {
    let words = '';

    if (number >= 20) {
        words += `${tens[Math.floor(number / 10)]} `;
        number %= 10;
    }

    if (number > 0) {
        words += `${ones[number]} `;
    }

    return words.trim();
}


  alertMessage(name, actions) {
    const message = name + ` has been ` + actions + ` successfully`;
    this.layoutUtilsService.showActionNotification(message, 10000, true);
  }
  alertSpecialMessage(message) {
    this.layoutUtilsService.showActionNotification(message, 10000, true);
  }
  alertNotificationMessage(err) {
    // this.layoutUtilsService.showAlertNotification(message, true);
    if (err == null) {
      this.layoutUtilsService.showAlertNotification('Unable to load Response', true);
      return;
    }
    if (err.statusText == 'Unknown Error') {
      this.layoutUtilsService.showAlertNotification('Looks like your network is having trouble. Check and retry in a moment.', true);
      return;
    }
    if (err.statusText == 'Not Acceptable') {
      const hasXToken = !!this.getCookie('x-token');
      const hasNoRedirect = !!this.getCookie('noRedirect');
      this.layoutUtilsService.showAlertNotification(err.error.message, true);
      localStorage.removeItem('token');
      localStorage.removeItem('isExternalLogin');
      localStorage.removeItem('name')
      localStorage.removeItem('userType');
      localStorage.removeItem('session');
      localStorage.removeItem('mobile');
      localStorage.removeItem('sessionEndDate');
      localStorage.removeItem('sessionStartDate');
      localStorage.removeItem('entityType');
      localStorage.removeItem('entityId');
      localStorage.removeItem('homeEntityId');
      localStorage.removeItem('logo')
      localStorage.removeItem('entityName')
      localStorage.removeItem('primaryColour')
      localStorage.removeItem('permissions')
      localStorage.removeItem('courseByTeacherData')
      localStorage.removeItem('courseByTeacherDataDateWise');
      localStorage.removeItem('estimatedCollections');
		localStorage.removeItem('estimatedCollectionsDate');
      this.removeCookie('x-token');
      this.removeCookie('noRedirect');
      if (hasXToken && !hasNoRedirect) {
        window.location.href = environment.extraMarksConfig.logout;
      } else {
        this.router.navigate(['/auth/signin']);
      }
      return;

    }
    if (err.status == 406) {
      const hasXToken = !!this.getCookie('x-token');
      const hasNoRedirect = !!this.getCookie('noRedirect');
      alert(err.error.message)
      localStorage.removeItem('token');
      localStorage.removeItem('isExternalLogin');
      localStorage.removeItem('name')
      localStorage.removeItem('userType');
      localStorage.removeItem('session');
      localStorage.removeItem('mobile');
      localStorage.removeItem('sessionEndDate');
      localStorage.removeItem('sessionStartDate');
      localStorage.removeItem('entityType');
      localStorage.removeItem('entityId');
      localStorage.removeItem('homeEntityId');
      localStorage.removeItem('logo')
      localStorage.removeItem('entityName')
      localStorage.removeItem('primaryColour')
      localStorage.removeItem('permissions')
      localStorage.removeItem('courseByTeacherData')
      localStorage.removeItem('courseByTeacherDataDateWise');
      localStorage.removeItem('estimatedCollections');
		localStorage.removeItem('estimatedCollectionsDate');
      this.removeCookie('x-token');
      this.removeCookie('noRedirect');
      if (hasXToken && !hasNoRedirect) {
        window.location.href = environment.extraMarksConfig.logout;
      } else {
        this.router.navigate(['/auth/signin']);
      }
      return;
    }
    if (err.status == 408) {
      this.confirmAlert('Need to Reload the page', 'Ok', '').subscribe(res => {
        if (res) {
          localStorage.removeItem('courseByTeacherData');
          localStorage.removeItem('courseByTeacherDataDateWise');
          window.location.reload();
        }
      });
      return;
    }
    if (err.statusText == 'Not Found') {
      this.layoutUtilsService.showAlertNotification('Invalid Request URL', true);
      return;
    }
    if (err && err.error && err.error.missingAttendance) {
      this.layoutUtilsService.showAlertNotification('Add Studdent Attendance Missssing Value', true);
      return;
    }
    if (err && err.error && err.error.message) {
      this.layoutUtilsService.showAlertNotification(err.error.message, true);
      return
    }
    if (err && err.message) {
      this.layoutUtilsService.showAlertNotification(err.message, true);
      return
    }
    else {
      this.layoutUtilsService.showAlertNotification(err, true);
      return
    }
  }
   confirmAlert(message,okButton: string = 'Ok',cancelButton: string = 'Cancel'){
     return this.layoutUtilsService.showConfirmNotification(message,okButton,cancelButton);
   }
  redirect(route) {
    this.router.navigate([route])
  }
  redirectRoute(route, id) {
    this.router.navigate([route, id])
  }
  redirectRoute2(route, id,flag) {
    this.router.navigate([route, id,flag])
  }
  trimData(data) {
    return data.trim();
  }
  getID() {
    const id = this.route.snapshot.paramMap.get('id');
    return id;
  }
  checkPermission(value) {
    if (this.permissions.includes(value)) {
      return true;
    } else {
      return false;
    }
  }
  startOfWeek(date) {
    var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);

    return new Date(date.setDate(diff));

  }
  endOfWeek(date) {

    var lastday = date.getDate() - (date.getDay() - 1) + 6;
    return new Date(date.setDate(lastday));

  }
  arraySort(data, sortByTest) {
    if (!data || !Array.isArray(data)) return;

    data.sort(function (a, b) {
      if (!a[sortByTest])
        return +1;
      else if (!b[sortByTest])
        return -1;
      else {
        if (sortByTest == 'date') {
          a.sortByTest = dayjs(new Date(a.sortByTest)).format('DD-MM-YYYY');
          b.sortByTest = dayjs(new Date(b.sortByTest)).format('DD-MM-YYYY');
          return Number(new Date(a[sortByTest])) - Number(new Date(b[sortByTest]));
        }

        if (isNaN(a[sortByTest])) {
          return (a[sortByTest].localeCompare(b[sortByTest], undefined, { numeric: true }))
        } else {
          return (a[sortByTest] - b[sortByTest])
        }
      }

    })
  }
  sortTheData(data, sortBy) {
    if (!data || !Array.isArray(data)) return;
    data.sort((a, b) => {
      // Convert names to lowercase for case-insensitive sorting
      const nameA = a[sortBy].toLowerCase();
      const nameB = b[sortBy].toLowerCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }
  arrayReverseSort(data, sortByTest) {
    if (!data || !Array.isArray(data)) return;
    data.sort(function (a, b) {
      if (!a[sortByTest])
        return +1;
      else if (!b[sortByTest])
        return -1;
      else {
        if (sortByTest == 'date') {
          a.sortByTest = dayjs(new Date(a.sortByTest)).format('DD-MM-YYYY');
          b.sortByTest = dayjs(new Date(b.sortByTest)).format('DD-MM-YYYY');
          return Number(new Date(b[sortByTest])) - Number(new Date(a[sortByTest]));
        }
        if (isNaN(a[sortByTest])) {
          return (b[sortByTest].localeCompare(a[sortByTest], undefined, { numeric: true }))
        } else {
          return (b[sortByTest] - a[sortByTest])
        }
      }
    })
  }
  numberToEnglish(n) {

    var string = n.toString(), units, tens, scales, start, end, chunks, chunksLen, chunk, ints, i, word, words, and = 'and';

    /* Remove spaces and commas */
    string = string.replace(/[, ]/g, "");

    /* Is number zero? */
    if (parseInt(string) === 0) {
      return 'zero';
    }

    /* Array of units as words */
    units = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];

    /* Array of tens as words */
    tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    /* Array of scales as words */
    scales = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion', 'decillion', 'undecillion', 'duodecillion', 'tredecillion', 'quatttuor-decillion', 'quindecillion', 'sexdecillion', 'septen-decillion', 'octodecillion', 'novemdecillion', 'vigintillion', 'centillion'];

    /* Split user arguemnt into 3 digit chunks from right to left */
    start = string.length;
    chunks = [];
    while (start > 0) {
      end = start;
      chunks.push(string.slice((start = Math.max(0, start - 3)), end));
    }

    /* Check if function has enough scale words to be able to stringify the user argument */
    chunksLen = chunks.length;
    if (chunksLen > scales.length) {
      return '';
    }

    /* Stringify each integer in each chunk */
    words = [];
    for (i = 0; i < chunksLen; i++) {

      chunk = parseInt(chunks[i]);

      if (chunk) {

        /* Split chunk into array of individual integers */
        ints = chunks[i].split('').reverse().map(parseFloat);

        /* If tens integer is 1, i.e. 10, then add 10 to units integer */
        if (ints[1] === 1) {
          ints[0] += 10;
        }

        /* Add scale word if chunk is not zero and array item exists */
        if ((word = scales[i])) {
          words.push(word);
        }

        /* Add unit word if array item exists */
        if ((word = units[ints[0]])) {
          words.push(word);
        }

        /* Add tens word if array item exists */
        if ((word = tens[ints[1]])) {
          words.push(word);
        }

        /* Add 'and' string after units or tens integer if: */
        if (ints[0] || ints[1]) {

          /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
          if (ints[2] || !i && chunksLen) {
            words.push(and);
          }

        }

        /* Add hundreds word if array item exists */
        if ((word = units[ints[2]])) {
          words.push(word + ' hundred');
        }

      }

    }

    return words.reverse().join(' ');

  }
  sortAssessmentsByStudentRegNo(assessments: any[], type: string) {
    // Use the Array.prototype.sort() method to sort the array by a custom comparator
    assessments.sort((a, b) => {
      const valueA = a[type]; // Access the dynamic sort field
      const valueB = b[type];

      // Check if the values are numbers or strings, and sort accordingly
      if (!isNaN(valueA) && !isNaN(valueB)) {
        return Number(valueA) - Number(valueB); // Numeric comparison
      } else {
        return valueA.localeCompare(valueB); // String comparison (case-insensitive)
      }
    });

    return assessments;
  }
  extractNumericPart(str) {
    const numericPart = str.match(/\d+/);
    return numericPart ? parseInt(numericPart[0], 10) : 0;
  }
  getMonthsBetweenDates(startDate: Date, endDate: Date): string[] {
    const months = [];
    const start = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const end = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

    while (start <= end) {
      const month = start.toLocaleString('default', { month: 'short' });
      months.push(month);
      start.setMonth(start.getMonth() + 1);
    }

    return months;
  }
  sortData(sort: MatSort, dataSource: any) {

    let last_item = dataSource.pop()
    if (!Object.values(last_item).includes("Total")) {
      dataSource.push(last_item)
    }
    let excelData = Object.assign({}, dataSource)
    const data: Array<UserData> = dataSource;
    if (!sort.active || sort.direction === '') {
      dataSource = data;
      return dataSource;
    }


    excelData = data.sort((a, b) => {


      let isAsc: boolean = sort.direction === 'asc';
      // for(let item of this.structureColumns){

      switch (sort.active) {
        case sort.active: return this.compare(a[sort.active], b[sort.active], isAsc,);
        default: return 0;
      }
    }

    );
    // dataSource = new MatTableDataSource<UserData>(excelData);
    if (Object.values(last_item).includes("Total"))
      dataSource.push(last_item)
    return dataSource



  }
  compare(a: any, b: any, isAsc: boolean): number {
    const valueA = (a !== null && a !== undefined && a !== '') ? a : '';
    const valueB = (b !== null && b !== undefined && b !== '') ? b : '';
    if (valueA < valueB) {
    return -1 * (isAsc ? 1 : -1);
  } else if (valueA > valueB) {
    return 1 * (isAsc ? 1 : -1);
  } else {
    return 0;
  }
  }


  calculateAge(dob) {
    var now = new Date();

    var yearNow = now.getFullYear();
    var monthNow = now.getMonth()+1;
    var dateNow = now.getDate();

    var yearDob =new Date(dob).getFullYear()
    var monthDob =new Date(dob).getMonth()+1; // Months are zero-based (0 = January, 1 = February, etc.)
    var dateDob = new Date(dob).getDate()

    var age: any = {};
    var ageString = "";
    var yearString = "";
    var monthString = "";
    var dayString = "";

    var yearAge = yearNow - yearDob;

    if (monthNow >= monthDob)
      var monthAge = monthNow - monthDob;
    else {
      yearAge--;
      var monthAge = 12 + monthNow - monthDob;
    }

    if (dateNow >= dateDob)
      var dateAge = dateNow - dateDob;
    else {
      monthAge--;
      var dateAge = 31 + dateNow - dateDob;

      if (monthAge < 0) {
        monthAge = 11;
        yearAge--;
      }
    }

    age = {
      years: yearAge,
      months: monthAge,
      days: dateAge
    };

    if (age.years > 1) yearString = " years";
    else yearString = " year";
    if (age.months > 1) monthString = " months";
    else monthString = " month";
    if (age.days > 1) dayString = " days";
    else dayString = " day";

    if ((age.years > 0) && (age.months > 0) && (age.days > 0))
      ageString = age.years + yearString + ", " + age.months + monthString + ", and " + age.days + dayString + " old.";
    else if ((age.years == 0) && (age.months == 0) && (age.days > 0))
      ageString = "Only " + age.days + dayString + " old!";
    else if ((age.years > 0) && (age.months == 0) && (age.days == 0))
      ageString = age.years + yearString + " old. Happy Birthday!!";
    else if ((age.years > 0) && (age.months > 0) && (age.days == 0))
      ageString = age.years + yearString + " and " + age.months + monthString + " old.";
    else if ((age.years == 0) && (age.months > 0) && (age.days > 0))
      ageString = age.months + monthString + " and " + age.days + dayString + " old.";
    else if ((age.years > 0) && (age.months == 0) && (age.days > 0))
      ageString = age.years + yearString + " and " + age.days + dayString + " old.";
    else if ((age.years == 0) && (age.months > 0) && (age.days == 0))
      ageString = age.months + monthString + " old.";
    else ageString = "Oops! Could not calculate age!";

    return ageString;
  }
  calculateAgeOnlyYear(dob: string | Date): string {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const m = today.getMonth() - birthDate.getMonth();
    const d = today.getDate() - birthDate.getDate();

    // If birthday hasn't occurred yet this year, subtract 1
    if (m < 0 || (m === 0 && d < 0)) {
      age--;
    }

    return `${age} year${age !== 1 ? 's' : ''}`;
  }


  calculateAgeFromSelectedDate(sessionStartDate, dob: string) {
    const sessionDate = new Date(sessionStartDate);
    const dobDate = new Date(dob);

    const yearSession = sessionDate.getFullYear();
    const monthSession = sessionDate.getMonth() + 1; // Months are zero-based
    const dateSession = sessionDate.getDate();

    const yearDob = dobDate.getFullYear();
    const monthDob = dobDate.getMonth() + 1;
    const dateDob = dobDate.getDate();

    let age: any = {};
    let ageString = "";
    let yearString = "";
    let monthString = "";
    let dayString = "";

    let yearAge = yearSession - yearDob;

    let monthAge;
    if (monthSession >= monthDob) {
      monthAge = monthSession - monthDob;
    } else {
      yearAge--;
      monthAge = 12 + monthSession - monthDob;
    }

    let dateAge;
    if (dateSession >= dateDob) {
      dateAge = dateSession - dateDob;
    } else {
      monthAge--;
      dateAge = 31 + dateSession - dateDob;

      if (monthAge < 0) {
        monthAge = 11;
        yearAge--;
      }
    }

    age = {
      years: yearAge,
      months: monthAge,
      days: dateAge,
    };

    if (age.years > 1) yearString = " years";
    else yearString = " year";

    if (age.months > 1) monthString = " months";
    else monthString = " month";

    if (age.days > 1) dayString = " days";
    else dayString = " day";

    if (age.years > 0 && age.months > 0 && age.days > 0)
      ageString = `${age.years}${yearString}, ${age.months}${monthString}, and ${age.days}${dayString} old.`;
    else if (age.years === 0 && age.months === 0 && age.days > 0)
      ageString = `Only ${age.days}${dayString} old!`;
    else if (age.years > 0 && age.months === 0 && age.days === 0)
      ageString = `${age.years}${yearString} old. Happy Birthday!!`;
    else if (age.years > 0 && age.months > 0 && age.days === 0)
      ageString = `${age.years}${yearString} and ${age.months}${monthString} old.`;
    else if (age.years === 0 && age.months > 0 && age.days > 0)
      ageString = `${age.months}${monthString} and ${age.days}${dayString} old.`;
    else if (age.years > 0 && age.months === 0 && age.days > 0)
      ageString = `${age.years}${yearString} and ${age.days}${dayString} old.`;
    else if (age.years === 0 && age.months > 0 && age.days === 0)
      ageString = `${age.months}${monthString} old.`;
    else ageString = "Oops! Could not calculate age!";

    return ageString;
  }

  sortWithSequence(data, type) {
    data.sort((a, b) => {
      return a[type] - b[type];
    });

  }
  sortCourse(data) {

    this.service.getCourseList(this.entityId, this.session)
      .subscribe(res => {
        this.allCourseList = res
        for (let item of data) {
          for (let val of this.allCourseList) {
            if (item.course == val.name) {
              item.sequenceNo = val.sequenceNo
            }
          }
        }

      }, err => {

      })

    return data

  }

  stringDate(dob) {
    if(!dob)
      return ''
    let date = dayjs(dob).format('DD-MM-YYYY');
    var stu = date.split('-');
    var wMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

    let final = this.toWords(stu[0]) + " " + wMonths[parseInt(stu[1]) - 1] + " " + this.toWords(stu[2])
    return final
  }
  imageURLChange(photo) {
    if (photo.includes("uc?export=download&id=")) {
      // Handles the case where the URL is a direct download link
      let modifiedUrl = photo.replace("uc?export=download&id=", "thumbnail?id=");
      modifiedUrl += '&sz=s4000';
      return modifiedUrl;
    } else if (photo.includes("drive.google.com/file/d/")) {
      // Use a regular expression to extract the file ID more reliably
      const match = photo.match(/\/d\/([a-zA-Z0-9_-]+)\//);
      if (match && match[1]) {
        const fileId = match[1];
        return `https://drive.google.com/thumbnail?id=${fileId}&sz=s4000`;
      }
    }
    // Return the original photo if it doesn't match the expected format
    return photo;
  }
  compressImage(file: File, options?: ImageCompressOptions): Promise<CompressedImageResult> {
    return this.imageCompressor.compressImage(file, options);
  }
  changeYearByCurrentSession(date,difference)
  {
    const originalDateString = date;
    // Parse the date string to create a Date object
    const originalDate = new Date(originalDateString);
    // // Increase the year by one
    // let sessionDate = new Date(localStorage.getItem('sessionStartDate'))
    // let difference= sessionDate.getFullYear() - originalDate.getFullYear()
    const newYear = originalDate.getFullYear() + difference;
    originalDate.setFullYear(newYear);
    // Convert the Date object back to ISO string format
    const newDateString = originalDate.toISOString();
    return newDateString

  }


  formatDateInMMMYY(date) {
    let dateObj = new Date(date);

    // Define month names
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Get month and year
    let month = monthNames[dateObj.getUTCMonth()]; // Correct indexing
    let year = String(dateObj.getUTCFullYear()).slice(-2); // Get last two digits of the year

    // Format the date to "MMM YY"
    let formattedDate = `${month} ${year}`;
    return formattedDate;
  }
  formatDateFromMMMYYToProperDate(date) {
    // Get the current date
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let currentMonth = currentDate.getMonth();

    // Extract month and year from the input date string
    let [monthStr, yearStr] = date.split(' ');

    // Define month names and get the month index
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let month = monthNames.indexOf(monthStr);
    let year = parseInt('20' + yearStr, 10);  // Convert year to full year (e.g., '24' -> '2024')

    // Construct the new date object to the first day of the parsed month and year
    let newDate = new Date(year, month, 1);

    // Ensure the date object is set to the first day of the parsed month and year
    newDate.setDate(1);

    return newDate;
  }

  formatDateInDDMMM(date) {
    if (!date) return '';
    let dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return date;

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let day = String(dateObj.getDate()).padStart(2, '0');
    let month = monthNames[dateObj.getMonth()];

    return `${day} ${month}`;
  }

  formatDateFromDDMMMToProperDate(date) {
    if (!date) return null;
    if (date instanceof Date) return date;
    if (typeof date === 'string' && date.includes(' ')) {
      let currentYear = new Date().getFullYear();
      let [dayStr, monthStr] = date.trim().split(' ');
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let month = monthNames.indexOf(monthStr);
      let day = parseInt(dayStr, 10);
      if (month !== -1 && !isNaN(day)) {
        return new Date(currentYear, month, day);
      }
    }
    return new Date(date);
  }

      formatDateTODDMMMYYYY(dateString)
      {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, '0');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
      }
      calculateTotalExperience(joiningDate: string, yearOfJoiningInService: number): string {
        const currentDate = new Date();
        const parsedJoiningDate = new Date(joiningDate);

        let years = currentDate.getFullYear() - parsedJoiningDate.getFullYear();
        let months = currentDate.getMonth() - parsedJoiningDate.getMonth();

        if (months < 0) {
          years--;
          months += 12;
        }

        years += yearOfJoiningInService ? Number(yearOfJoiningInService):0 ;

        return `${years} years ${months} months`;
      }
      getTimeFromDate(date)
      {
        const now = new Date(date);

        const hours = now.getHours(); // Hours (0–23)
        const minutes = now.getMinutes(); // Minutes (0–59)
        const seconds = now.getSeconds(); // Seconds (0–59)
        const milliseconds = now.getMilliseconds(); // Milliseconds (0–999)

        return `${hours}:${minutes}:${seconds}`
      }

      calculateDateDifference( expectedReturnDateStr) {
        const todaysDate = new Date();
        const expectedReturnDate = new Date(expectedReturnDateStr);

        // Calculate the difference in milliseconds
        const differenceInMillis = todaysDate.getTime() - expectedReturnDate.getTime();

        // Convert milliseconds to days
        const differenceInDays = differenceInMillis / (1000 * 60 * 60 * 24);

        return Number(differenceInDays.toFixed(0));
      }
      arrayCourseSort(data, sortByTest) {
        data.sort((a, b) => {
          const valueA = a[sortByTest] || "";
          const valueB = b[sortByTest] || "";

          // Extract numeric parts from the string
          const numA = parseInt(valueA.match(/\d+/)[0] || "0", 10);
          const numB = parseInt(valueB.match(/\d+/)[0] || "0", 10);

          // First, compare by the extracted number
          if (numA !== numB) {
            return numA - numB;
          }

          // If numbers are the same, fall back to string comparison
          return valueA.localeCompare(valueB);
        });
      }

      sortSubjectComparison(data: any[], sortBy: keyof typeof data[0]['subjectWise'][0], order: 'asc' | 'desc' = 'asc') {
        for (let session of data) {
          session.subjectWise.sort((a: any, b: any) => {
            const aValue = a[sortBy];
            const bValue = b[sortBy];

            if (typeof aValue === 'string' && typeof bValue === 'string') {
              return order === 'asc'
                ? aValue.localeCompare(bValue)
                : bValue.localeCompare(aValue);
            } else {
              return order === 'asc'
                ? (aValue - bValue)
                : (bValue - aValue);
            }
          });
        }
      }

      generatePrefixedRange(prefix: string, start: number, end: number, numLength: number): string[] {
        return Array.from({ length: end - start + 1 }, (_, i) => `${prefix}${String(start + i).padStart(numLength, '0')}`);
      }
      convertTo12Hour(time: string): string {
        if (!time) return '';
        const [hourStr, minute] = time.split(':');
        let hour = parseInt(hourStr, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12; // convert 0 to 12 for 12 AM
        return `${hour}:${minute} ${ampm}`;
      }
      formatDate(dateStr: string): string {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
  }

smartToggleDisplay(id: string): void {
  const el = document.getElementById(id) as HTMLElement | null;
  if (!el) return;

  // Save original display type (if not saved yet)
  if (!el.dataset.origDisplay) {
    const computed = window.getComputedStyle(el).display;
    el.dataset.origDisplay = (computed !== 'none') ? computed : 'block';
  }

  // Toggle
  if (window.getComputedStyle(el).display === 'none') {
    el.style.display = el.dataset.origDisplay; // Restore original
  } else {
    el.style.display = 'none';
  }
}
  hideByDefault(ids: string[]): void {
    ids.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.style.display = 'none';
      }
    });
  }

  calculateServicePeriod(currentDate: any, terminationDate: any): string {
    if (!terminationDate) {
      return '-';
    }

    const current = moment(currentDate).startOf('day');
    const termination = moment(terminationDate).startOf('day');

    if (termination.isBefore(current)) {
      return 'Already Terminated';
    }

    const tempCurrent = current.clone();
    const years = termination.diff(tempCurrent, 'years');
    tempCurrent.add(years, 'years');

    const months = termination.diff(tempCurrent, 'months');
    tempCurrent.add(months, 'months');

    const days = termination.diff(tempCurrent, 'days') + 1;

    let result = '';
    if (years > 0) {
      result += `${years} Year${years > 1 ? 's' : ''} `;
    }
    if (months > 0) {
      result += `${months} Month${months > 1 ? 's' : ''} `;
    }
    if (days > 0 || result === '') {
      result += `${days} Day${days > 1 ? 's' : ''}`;
    }

    return result.trim();
  }
calculateTotalExperienceInYears(
  joiningDate: string,
  yearOfJoiningInService: Date
): number {

  const currentDate = new Date();
  const parsedJoiningDate = new Date(joiningDate);

  // Current job experience
  const monthsFromJoining =
    (currentDate.getFullYear() - parsedJoiningDate.getFullYear()) * 12 +
    (currentDate.getMonth() - parsedJoiningDate.getMonth());

  let totalMonths = monthsFromJoining;

  // Previous service experience
  if (yearOfJoiningInService) {
    const serviceDate = new Date(yearOfJoiningInService);

    const monthsFromService =
      (currentDate.getFullYear() - serviceDate.getFullYear()) * 12 +
      (currentDate.getMonth() - serviceDate.getMonth());

    totalMonths += monthsFromService;
  }

  const experienceInYears = totalMonths / 12;

  return Number(experienceInYears.toFixed(1));
}

  getParentDomain(): string {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // If it's a 2-part domain like extramarks.com, use it as is
    if (parts.length < 3) {
      return hostname;
    }

    // Get the last two parts (e.g., 'odpay.in' or 'web.app')
    const baseDomain = parts.slice(-2).join('.');
    const parent = '.' + baseDomain;

    // Safety check: If the last two parts are a public platform suffix,
    // we must use the full hostname to avoid browser blocking.
    const platformSuffixes = ['.web.app', '.firebaseapp.com', '.github.io', '.herokuapp.com', '.azurewebsites.net'];
    if (platformSuffixes.includes(parent)) {
      return hostname;
    }

    return parent;
  }

  setCookie(name: string, value: string, days?: number) {
    let expires = "";
    if (days !== undefined && days !== null) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }

    const domain = this.getParentDomain();
    // Don't set domain for localhost to avoid issues
    const domainPart = (domain && !hostnameIsLocal(window.location.hostname)) ? "; domain=" + domain : "";

    // Add Secure attribute for HTTPS connections
    const securePart = window.location.protocol === 'https:' ? "; Secure" : "";

    document.cookie = name + "=" + (value || "") + expires + "; path=/" + domainPart + "; SameSite=Lax" + securePart;

    function hostnameIsLocal(host: string): boolean {
      return host === 'localhost' || host === '127.0.0.1' || host.startsWith('192.168.') || host.startsWith('10.');
    }
  }

  getCookie(name: string) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  removeCookie(name: string) {
    this.setCookie(name, "", -1);
  }
}
